import classNames from 'classnames';

import { Button } from '../../button/button.component';

import WistiaModal from '../wistia-modal/wistia-modal';
import { WistiaCtaProps } from './wistia-cta.config';

const WistiaCta = ({ additionalClasses, ctaText, isLink = true, onClose, onOpen, open, ...props }: WistiaCtaProps) => {
  return (
    <div data-testid="snowflake-wistia-cta" className={additionalClasses}>
      <Button
        appliedCssClassNames={classNames({ 'snowflake-button-link': isLink })}
        onClick={onOpen}
        text={ctaText}
        disableAnchor
      />
      <WistiaModal open={open} onClose={onClose} {...props} />
    </div>
  );
};

export default WistiaCta;
